import { Component, computed, inject } from '@angular/core';
import { environment } from '@/environments/environment';
import { MetrikaService } from '@/services/metrika/metrika.service';

@Component({
  selector: 'app-metrika-noscript',
  standalone: true,
  // Browsers with JS enabled parse <noscript> children as a text node, not elements (NG0500).
  host: { ngSkipHydration: '' },
  template: `
    @if (visible()) {
      <noscript>
        <div>
          <img [src]="watchUrl()" style="position:absolute; left:-9999px;" alt="" />
        </div>
      </noscript>
    }
  `,
})
export class MetrikaNoscriptComponent {
  private readonly metrika = inject(MetrikaService);

  readonly visible = this.metrika.noscriptVisible;
  readonly watchUrl = computed(() => `https://mc.yandex.ru/watch/${environment.metrika.counterId}`);
}
